import { defineComponent } from 'vue';
import SupplierComponent from '@/components/SupplierComponent.vue';
export default defineComponent({
    name: 'SupplierDialog',
    props: {
        propSelected: Array
    },
    components: { SupplierComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
